/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type children_AllergyRequest = {
    comment?: string;
    id?: string;
    name: string;
    severity?: children_AllergyRequest.severity;
};
export namespace children_AllergyRequest {
    export enum severity {
        MILD = 'MILD',
        MODERATE = 'MODERATE',
        SEVERE = 'SEVERE',
    }
}

